import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { theme } from './shared';

export function ProfileListingEmpty({ translationKey }: { translationKey: string }) {
  const { t } = useTranslation();
  return (
    <Text
      variant="bodyBase"
      color="text.placeholder"
      textAlign="center"
      style={{ marginTop: theme.spacing['spacing.general.x5'] }}
    >
      {t(translationKey, { ns: 'neighbour-profile' })}
    </Text>
  );
}
